import React, { createContext, useReducer, useContext } from 'react';
import axios from "axios";
import cookie from "react-cookies";
import {RECEIVER_COOKIE_KEY} from "./constant";


const initialState = {
  loading: true,
  data: null,
  error: null
};


function warehouseReducer(state, action){

  switch(action.type){
    case 'GET_WAREHOUSE':
      return {
        ...state,
        loading : true,
      };
    case 'GET_WAREHOUSE_SUCCESS':
      return {
        // ...state,
        data: action.data,
        error: null,
        loading : false,
      };
    case 'GET_WAREHOUSE_ERROR':
      return {
        // ...state,
        data: action.data,
        error: action.error,
        loading : false,
      };
    default:
      throw new Error(`Unhanded action type: ${action.type}`);
  }
}


const WarehouseStateContext = createContext(null);
const WarehouseDispatchContext = createContext(null);



export function WarehouseProvider({ children }) {
  const [state, dispatch] = useReducer(warehouseReducer, initialState);
  return (
    <WarehouseStateContext.Provider value={state}>
      <WarehouseDispatchContext.Provider value={dispatch}>
        {children}
      </WarehouseDispatchContext.Provider>
    </WarehouseStateContext.Provider>
  );
}

export function useWarehouseState() {
  const state = useContext(WarehouseStateContext);
  if (!state) {
    throw new Error('Cannot find WarehouseStateContext');
  }
  return state;
}

export function useWarehouseDispatch() {
  const dispatch = useContext(WarehouseDispatchContext);
  if (!dispatch) {
    throw new Error('Cannot find WarehouseDispatchContext');
  }
  return dispatch;
}


export async function getWarehouse(dispatch) {

  dispatch({ type: 'GET_WAREHOUSE' });

  console.log("getWarehouse start => ")
  try {
    const response = await axios.get(`${process.env.REACT_APP_API_HOST}/warehouse`, {
      headers: { 'Content-type': 'application/x-www-form-urlencoded', },
      params: {
        token: cookie.load(RECEIVER_COOKIE_KEY),
      },
    });
    console.log("getWarehouse result => ", response.data)
    if(response.status === 200 && response.data != null && response.data.code === 200){
      dispatch({ type: 'GET_WAREHOUSE_SUCCESS', data: response.data });
    }else{
      dispatch({ type: 'GET_WAREHOUSE_ERROR', error: 'cannot access to server', data: response.data });
    }

  } catch (e) {
    dispatch({ type: 'GET_WAREHOUSE_ERROR', error: e });
  }
}

